import appConstants from "../../../appConstants";
import { getSvgIcons } from "../../modules/Dispatch/utils/svgIcons";
const getCombinedIconsArray = (shipmentData,specialNeedsOptions) => {
  // Create a dictionary from appConstant's SpecialNeeds Object Array
  // where key is special need code and value is entire object
  const specialNeeds = {};
  specialNeedsOptions.forEach(data => (specialNeeds[data.value] = data));

  // Combined icons array contains all the icons which the given shipment satisfy
  const combinedIconsArray = [];

  // Insert the icon for APT shipment
  shipmentData.apt === "APT" && combinedIconsArray.push(specialNeeds["APT"]);

  // Insert the icon for the Shipment Priority
  shipmentData.priority &&
    specialNeeds[shipmentData.priority] &&
    combinedIconsArray.push(specialNeeds[shipmentData.priority]);

  // Insert the icon for the liftgate
  shipmentData.liftgate && combinedIconsArray.push(specialNeeds["L"]);

   // Insert the icon for the isTrailerDrop
  shipmentData.isTrailerDrop && combinedIconsArray.push(specialNeeds[appConstants.SpecialNeedsStrings.TrailerDrop]);

  // Insert the icon for Pup
  shipmentData.eqpmtPref &&
    ["Pup", "Pup LG"].includes(shipmentData.eqpmtPref) &&
    combinedIconsArray.push(specialNeeds["Pup"]);

  /*
  Insert the icon for special instruction
  conditional matching of both field are required as getCombinedIconsArray used for shipmentPopupInfo, stopPopupInfo
  */
  (shipmentData.specialInstruction || shipmentData.shipmentSpecialInstruction) &&
    combinedIconsArray.push(specialNeeds["specialInstruction"]);

  (shipmentData.excessiveLength === appConstants.EXCESSIVE_SHIPMENT.YES &&
    combinedIconsArray.push(
      specialNeeds[appConstants.SpecialNeedsStrings.ExcessiveLength]
    )
  );

  // Array of special need codes; Fill by splitting CSV string
  const specialNeedsCodes = [];
  shipmentData.specialNeeds &&
    shipmentData.specialNeeds
      .split(",")
      .map(specialNeed => specialNeedsCodes.push(specialNeed));

  // Insert the icons for special instruction
  specialNeedsCodes.forEach(code => {
    if (specialNeeds[code]) {
      combinedIconsArray.push(specialNeeds[code]);
    }
  });

   //customer/shipper comments
if (shipmentData.customerComments && shipmentData.isDelivery) {
  const iconDetails = specialNeeds[appConstants.SpecialNeedsStrings.CC];
  combinedIconsArray.push({
   ...iconDetails,
    tooltip: shipmentData.customerComments,
  });
} else if (shipmentData.shipperComments && !shipmentData.isDelivery) {
  const iconDetails = specialNeeds[appConstants.SpecialNeedsStrings.SC];
  combinedIconsArray.push({
    ...iconDetails,
    tooltip: shipmentData.shipperComments,
  });
}

  return combinedIconsArray;
};

const getIconByType = (iconData) => {
  return iconData?.svgIcon ? (
    getSvgIcons(iconData.svgIcon, "white")
  ) : (
    <i className={iconData.icon} />
  );
};

export {
  getCombinedIconsArray,
  getIconByType,
}